import React from 'react';
import { Users, Sparkles } from 'lucide-react';

/**
 * Time Literário Ativo
 * Elemento visual simbólico que representa a presença do conselho de agentes IA
 * Deve ser discreto, acolhedor e inspirador
 */
const TimeLiterarioAtivo = ({ className = "", compact = false, customIcon = null }) => {
  if (compact) {
    return (
      <div 
        className={`flex items-center gap-2 px-3 py-2 rounded-lg bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/20 ${className}`}
        title="Seu Time Literário está ativo"
      >
        <div className="relative">
          {customIcon || <Users size={16} className="text-amber-600 dark:text-amber-400" />}
          <Sparkles size={8} className="absolute -top-1 -right-1 text-amber-500 animate-pulse" />
        </div>
        <span className="text-xs font-medium text-amber-700 dark:text-amber-300">
          Time Ativo
        </span>
      </div>
    );
  }

  return (
    <div 
      className={`p-4 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-950/30 dark:to-orange-950/30 border border-amber-200/50 dark:border-amber-800/30 ${className}`}
    >
      <div className="flex items-start gap-3">
        <div className="relative flex-shrink-0">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow-lg shadow-amber-500/20">
            <Users size={20} className="text-white" />
          </div>
          <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-green-500 border-2 border-white dark:border-gray-900 flex items-center justify-center">
            <Sparkles size={8} className="text-white" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-amber-900 dark:text-amber-100">
            Time Literário Ativo
          </h4>
          <p className="text-xs text-amber-700/80 dark:text-amber-300/80 mt-0.5">
            Seu conselho editorial está pronto para ajudar
          </p>
        </div>
      </div>
      
      {/* Agentes ativos - visual sutil */}
      <div className="mt-3 flex items-center gap-1">
        {['A', 'G', 'E', 'R', 'C'].map((initial, i) => (
          <div 
            key={i}
            className="w-6 h-6 rounded-full bg-white/80 dark:bg-gray-800/80 border border-amber-200 dark:border-amber-700 flex items-center justify-center text-[10px] font-bold text-amber-600 dark:text-amber-400 shadow-sm"
            title={['Arquiteto', 'Ghostwriter', 'Editor', 'Revisor', 'Curador'][i]}
          >
            {initial}
          </div>
        ))}
        <span className="text-[10px] text-amber-600/70 dark:text-amber-400/70 ml-1">
          +3 agentes
        </span>
      </div>
    </div>
  );
};

export default TimeLiterarioAtivo;
